import { useEffect, useState } from 'react';
import { abbreviatedSha } from '~build/git';
import now from '~build/time';

import { useAppDispatch, useAppSelector } from '../../../store';
import { performStage } from '../../bootstrapper/functions';
import { usePluginContext } from '../../plugin/hooks';
import { Dialog } from './Dialog';
import { format } from 'date-fns';
import { currentModalSelector } from '../selectors';
import { uiActions } from '../slice';
import { useAccount } from '../../account/hooks';


export const Loader = () => {

  const caption = useAppSelector((state) => state.bootstrapper.caption);
  const currentStage: number = useAppSelector((state) => state.bootstrapper.currentStage);
  const totalStages: number = useAppSelector((state) => state.bootstrapper.totalStages);
  const loadFinished = useAppSelector((state) => state.bootstrapper.ready);
  const loadFailed = useAppSelector((state) => state.bootstrapper.failed);

  const account = useAccount();

  const dispatch = useAppDispatch();
  const pluginContext = usePluginContext();

  const progressPercent = Math.floor((100 * currentStage) / totalStages);

  const [visible, setVisible] = useState<boolean>(true);
  const currentModal = useAppSelector(currentModalSelector);

  useEffect(
    () => {
      if (account) {
        if (!loadFinished && !loadFailed) {
          const timeout = setTimeout(
            () => dispatch(performStage(pluginContext)),
            100
          );

          return () => {
            clearTimeout(timeout);
          };
        }
        else {
          setVisible(false);
        }
      }
      else if (!currentModal && !account) {
        dispatch(uiActions.setCurrentModal({ modal: 'login' }));
      }
      else {
        setVisible(true);
      }
    },
    [account, currentModal, dispatch, currentStage, loadFailed, loadFinished, pluginContext]
  );

  return (
    <Dialog show={visible && !currentModal}>
      <h2 className='text-center text-2xl'>JustWords</h2>
      <p>{caption}</p>
      <div className="w-full bg-jw-blue rounded-sm h-2.5 flex items-center justify-start border border-white">
        <div
          className="bg-white h-2.5 rounded-sm transition-all"
          style={{ width: `${progressPercent}%` }}></div>
      </div>
      <p className='text-sm text-neutral-400'>
        JustWords build {abbreviatedSha} - {format(now, "yyyy-MM-dd HH:mm:ss")}
      </p>
    </Dialog>
  );
};
